"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CarouselLogo;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("swiper/react");
require("swiper/swiper.min.css");
require("../asset/css/carousel.css");
var _logo_amp = _interopRequireDefault(require("../asset/logos/logo_amp.svg"));
var _logo_CCIMP = _interopRequireDefault(require("../asset/logos/logo_CCIMP.svg"));
var _logo_Conseil_Départemental_ = _interopRequireDefault(require("../asset/logos/logo_Conseil_D\xE9partemental_13.svg"));
var _logo_Etat = _interopRequireDefault(require("../asset/logos/logo_Etat.svg"));
var _logo_Euromediterranee = _interopRequireDefault(require("../asset/logos/logo_Euromediterranee.svg"));
var _logo_GPMM = _interopRequireDefault(require("../asset/logos/logo_GPMM.svg"));
var _logo_Ville_de_Marseille = _interopRequireDefault(require("../asset/logos/logo_Ville_de_Marseille.svg"));
var _logo_Région_SUD_PACA = _interopRequireDefault(require("../asset/logos/logo_R\xE9gion_SUD_PACA.svg"));
var _swiper = require("swiper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function CarouselLogo(props) {
  const {
    fos,
    amp,
    cciamp,
    dept13,
    etat,
    euroMed,
    marseille,
    regionSud
  } = props;
  let nombreDeLogos = Object.keys(props).length;
  const [nombreDeSlide, setNomndreDeSlide] = (0, _react.useState)(nombreDeLogos);
  const [swiperWidth, setSwiperWidth] = (0, _react.useState)();
  function carouselResponsive(largeurEcran) {
    if (nombreDeLogos >= 4) {
      if (largeurEcran > 1279) {
        setSwiperWidth("610");
        setNomndreDeSlide(4);
      }
      if (largeurEcran < 1279 && largeurEcran > 1129) {
        setSwiperWidth("440");
        setNomndreDeSlide(3);
      }
      if (largeurEcran < 1128 && largeurEcran > 900) {
        setSwiperWidth("306");
        setNomndreDeSlide(2);
      }
      if (largeurEcran < 900) {
        setSwiperWidth("152");
        setNomndreDeSlide(1);
      }
    }
    if (nombreDeLogos === 3) {
      if (largeurEcran > 1129) {
        setSwiperWidth("440");
        setNomndreDeSlide(3);
      }
      if (largeurEcran < 1128 && largeurEcran > 900) {
        setSwiperWidth("306");
        setNomndreDeSlide(2);
      }
      if (largeurEcran < 900) {
        setSwiperWidth("152");
        setNomndreDeSlide(1);
      }
    }
    if (nombreDeLogos === 2) {
      if (largeurEcran > 900) {
        setSwiperWidth("306");
        setNomndreDeSlide(2);
      }
      if (largeurEcran < 900) {
        setSwiperWidth("152");
        setNomndreDeSlide(1);
      }
    }
    if (nombreDeLogos === 1) {
      setSwiperWidth("152");
      setNomndreDeSlide(1);
    }
  }
  window.addEventListener('resize', () => {
    let largeurEcran = window.innerWidth;
    carouselResponsive(largeurEcran);
  });
  (0, _react.useEffect)(() => {
    let largeurEcran = window.innerWidth;
    carouselResponsive(largeurEcran);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react2.Swiper, {
    spaceBetween: 2,
    slidesPerView: nombreDeSlide,
    initialSlide: 0,
    centeredSlides: false,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    modules: [_swiper.Autoplay],
    className: "mySwiper",
    style: {
      width: "".concat(swiperWidth, "px")
    }
  }, fos && /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.marseille-port.fr/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "logo fos sur mer",
    className: "carousel-image image-large ",
    src: _logo_GPMM.default
  }))), amp && /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://ampmetropole.fr/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "logo m\xE9ropole Aix Marseille Provence",
    className: "carousel-image",
    src: _logo_amp.default
  }))), cciamp && /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.cciamp.com/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "logo chambre de commerce et de l'industrie m\xE9tropole Aix Marseille",
    className: "carousel-image image-large ",
    src: _logo_CCIMP.default
  }))), dept13 && /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.departement13.fr/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "logo d\xE9partement Bouches-du-Rh\xF4ne",
    className: "carousel-image image-large ",
    src: _logo_Conseil_Départemental_.default
  }))), etat && /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.gouvernement.fr/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "logo \xE9tat fran\xE7ais",
    className: "carousel-image",
    src: _logo_Etat.default
  }))), euroMed && /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.euromediterranee.fr/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "logo Eurom\xE9diterran\xE9e",
    className: "carousel-image image-large",
    src: _logo_Euromediterranee.default
  }))), marseille && /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.marseille.fr/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "logo ville de Marseille",
    className: "carousel-image image-large",
    src: _logo_Ville_de_Marseille.default
  }))), regionSud && /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.maregionsud.fr/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "logo R\xE9gion Sud PACA",
    className: "carousel-image",
    src: _logo_Région_SUD_PACA.default
  })))));
}